document.addEventListener('DOMContentLoaded', () => {
  // Cart Drawer Logic
  const cartDrawer = document.getElementById('cartDrawer');
  const cartBackdrop = document.getElementById('cartBackdrop');
  const cartPanel = document.getElementById('cartPanel');
  const cartOpenBtns = document.querySelectorAll('#cartDrawerOpen, [href="#bag"]');
  const cartCloseBtn = document.getElementById('cartDrawerClose');

  function openCart(e) {
    if (e) e.preventDefault();
    if (!cartDrawer) return;
    cartDrawer.classList.remove('pointer-events-none');
    cartBackdrop.classList.remove('opacity-0');
    cartPanel.classList.remove('translate-x-full');
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartBackdrop.classList.add('opacity-0');
    cartPanel.classList.add('translate-x-full');
    setTimeout(() => {
      cartDrawer.classList.add('pointer-events-none');
    }, 300);
  }

  cartOpenBtns.forEach(btn => btn.addEventListener('click', openCart));
  if (cartCloseBtn) cartCloseBtn.addEventListener('click', closeCart);
  if (cartBackdrop) cartBackdrop.addEventListener('click', closeCart);

  // Tab Switcher Logic
  window.setTab = function(tabIdx) {
    const triggers = document.querySelectorAll('.tab-trigger');
    const contents = document.querySelectorAll('.tab-content');

    triggers.forEach((btn, i) => {
      if (i === tabIdx) {
        btn.classList.add('border-primary', 'text-primary', 'font-semibold');
        btn.classList.remove('border-transparent', 'text-text-muted');
      } else {
        btn.classList.remove('border-primary', 'text-primary', 'font-semibold');
        btn.classList.add('border-transparent', 'text-text-muted');
      }
    });

    contents.forEach((content, i) => {
      if (i === tabIdx) {
        content.classList.add('active');
      } else {
        content.classList.remove('active');
      }
    });
  };

  // Image Switcher Logic
  window.switchImage = function(index) {
    const thumbs = document.querySelectorAll('.thumb-btn');
    thumbs.forEach((t, i) => {
      if (i === index) {
        t.classList.remove('opacity-70', 'ring-transparent');
        t.classList.add('ring-2', 'ring-primary');
      } else {
        t.classList.remove('ring-2', 'ring-primary');
        t.classList.add('opacity-70', 'ring-transparent');
      }
    });
    
    // Quick visual feedback on the main image
    const mainImg = document.getElementById('main-product-image');
    if (mainImg) {
      mainImg.style.opacity = '0.5';
      setTimeout(() => {
        mainImg.style.opacity = '1';
      }, 150);
    }
  };
});
